/** Tiny classnames join — filters out falsy values. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}

/** Day route color token index (cycles 1..7), per UI_KIT.md. */
export function dayColorVar(dayIndex: number): string {
  return `var(--color-st-day-${(dayIndex % 7) + 1})`
}
